'use strict';

var i18n = require('utils/i18n');

var ConnectionInfoDialogView = Marionette.ItemView.extend({
    template: require('components/devices/templates/gateway/connection_info_dialog'),

    warningColor: 'rgb(191,0,0)',
    dateFormat: 'DD.MM.YYYY, hh:mm',

    initialize: function (options) {
        this.requestDone = false;
        this.infoReq = options.infoReq;
        this.error = undefined;
    },

    templateHelpers: function () {
        return {
            connectionInfos: this.connectionInfos,
            requestDone: this.requestDone,
            error: this.error,
            infos: this.connectionInfos,
        };
    },

    prepareInfos: function (json) {
        return [
            {
                header: i18n.TR('SIM-Karte'),
                fields: [
                    { name: i18n.TR('IMEI'), value: json.imei },
                    { name: i18n.TR('IMSI'), value: json.imsi },
                    { name: 'divider', value: '' },
                    { name: i18n.TR('Aktivierungsstatus'), value: json.lifeCycleStatus },
                    { name: i18n.TR('Aktivierung'), value: moment(json.activationDate).format(this.dateFormat) },
                ],
            },
            {
                header: i18n.TR('Verbindung'),
                fields: [
                    { name: i18n.TR('Tag'), value: json.consumptionDaily.data.value / 1024 + ' kByte' },
                    {
                        name: i18n.TR('Monat'),
                        value: Math.round(json.consumptionMonthly.data.value / 102400) / 10 + ' MByte',
                    },
                    { name: 'divider', value: '' },
                    { name: i18n.TR('APN'), value: json.presence.apn },
                    { name: i18n.TR('Provider'), value: json.presence.sgsn.operator.company },
                    { name: i18n.TR('Ländercode'), value: json.presence.sgsn.operator.countryCode },
                ],
            },
        ];
    },

    onShow: function () {
        // replace spinner with the received content/or error
        var self = this;
        $.when(this.infoReq).done(function (response) {
            var data;

            if (response.responseText && response.responseText != '') {
                self.error = response.responseText;
            } else {
                data = response.subscriptionDetailData;
                data.imei = data.imei.split('-').join('');

                self.connectionInfos = self.prepareInfos(data);
            }

            self.requestDone = true;
            self.render();

            // stored imei != imei from Telefonica? -> mark it red
            if (!self.error && data.imei != data.deviceImei) {
                $($('#js-0').children('dl').children()[0]).css('color', self.warningColor);
                $($('#js-0').children('dl').children()[1]).css('color', self.warningColor);
            }

            // high data consumption (> 30 MByte) -> mark it red
            if (!self.error && data.consumptionMonthly.data.value / 1024 / 1000 > 30) {
                $($('#js-1').children('dl').children()[2]).css('color', self.warningColor);
                $($('#js-1').children('dl').children()[3]).css('color', self.warningColor);
            }
        });

        $('#js-modal-dialog .modal-dialog').addClass('modal-lg');
    },
});

module.exports = ConnectionInfoDialogView;
